import { Form } from "react-bootstrap";
import { SearchableDropdownContainer } from "./Components";
import { ErrorMessage, Field } from "formik";
import Select from 'react-select';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Required } from "../FormInput/Components";
import { useCallback } from "react";

export default function SearchableDropdown({label, options, forceLTR, isRequired, formik, defaultValue, onSelected, placeholder, onLoadData, disableGroup, customStyles, theme, width, ...props}){
    const { name } = props;
    const { t } = useTranslation();
    const {touched, errors} = formik;
    const [isLoading, setIsLoading] = useState(onLoadData?true:false);
    const [data, setData] = useState(options??[]);
    const { setFieldValue } = formik;
    const fetchData = useCallback(async () => {
        if (onLoadData) {
            setIsLoading(true);
            const data = await onLoadData();
            setData(data);
            setIsLoading(false);
        }
    }, [onLoadData]);
    useEffect(() => {
        
        fetchData();
    }, [fetchData])
    useEffect(() => {
        console.log(options)
        if(options){
            if(options.length === 0){
                setIsLoading(true);
            }else{
                setIsLoading(false);
            }
            setData(options)
        }
        
    }, [options])
    useEffect(() => {
        if(defaultValue){
            setFieldValue(name, defaultValue);
            if(onSelected)
                onSelected(defaultValue)
        }else{
            setFieldValue(name, null);
        }
        
    }, [defaultValue, setFieldValue, name])
    // useEffect(() => {
    //     if(props.name !== "country") return;
    //     if(defaultValue){
    //         setFieldValue(props.name, defaultValue)
    //         if(onSelected)
    //             onSelected(defaultValue)
    //     }else{
    //         setFieldValue(props.name, "")
    //     }
    // }, [defaultValue, onSelected, props.name, setFieldValue])
    const styles = {
        control: (provided, state) => ({
          ...provided,
          backgroundColor: 'var(--bs-body-bg)',
          borderColor: state.isFocused ? 'var(--bs-border-hover-color)' : 'var(--bs-border-color)',
          color: 'var(--bs-body-color)',
          borderRadius: 'var(--bs-border-radius)',
          padding: '.235em .7em',
          borderWidth: '2px !important',
          '&:hover': {
            borderColor: 'var(--bs-border-hover-color)',
            color: 'var(--bs-body-focus-color)'
          },
          '&:focus': {
            backgroundColor: 'var(--bs-body-focus-bg)',
            borderColor: 'var(--bs-border-hover-color)',
            color: 'var(--bs-body-focus-color)',
            boxShadow: '0 0 0 .1rem var(--bs-box-shadow)'
          }
        }),
        singleValue: (provided) => ({
            ...provided,
            color: 'var(--bs-body-color)',
            fontSize: '1.1em'
        }),
        input: (provided) => ({
            ...provided,
            color: 'var(--bs-body-color)',
            fontSize: '1.1em'
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected
            ? 'var(--primary-color)'
            : state.isFocused
            ? 'var(--bs-border-color)'
            : null,
          color: 'var(--bs-body-color)',
          padding: '.3em 1em',
        }),
        menu: (provided) => ({
          ...provided,
          backgroundColor: 'var(--bs-body-focus-bg)',
          borderRadius: 'var(--bs-border-radius)',
          borderColor: 'var(--bs-border-color)',
          color: 'var(--bs-body-color)',
          zIndex: 9999,
          ...(forceLTR && {
            direction: 'ltr'
          })
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            backgroundColor: 'var(--bs-border-color)'
        })
      };
    const renderInput = () => {
        return (
            <SearchableDropdownContainer className={(touched[name] && errors[name]?"is-invalid":"")+(theme && theme === "light"?" input-light":"")} style={width?{minWidth: width}:{}}>
                {label && <Form.Label>{label} {isRequired && <Required>*</Required>}</Form.Label>}
                <Field name={name}>
                {({ field }) => {
                    return (
                        <Select
                            styles={customStyles??styles}
                            {...props}
                            options={data}
                            classNamePrefix={"react-select"}
                            onChange={(selectedValue) => {
                                formik.setFieldValue(field.name, selectedValue)
                                if(onSelected)
                                    onSelected(selectedValue)
                            }}
                            onBlur={field.onBlur}
                            value={field.value}
                            isDisabled={isLoading || data.length === 0}
                            placeholder={isLoading?t("Loading..."):(placeholder??t("Search..."))}
                        />
                    )   
                }}
                </Field>
                {touched[name] && errors[name] && <ErrorMessage name={name}>
                    {(msg) => <Form.Control.Feedback type="invalid">{msg}</Form.Control.Feedback>}
                </ErrorMessage>}
            </SearchableDropdownContainer>
        )
    }
    if(disableGroup) return renderInput();
    return (
        <Form.Group className="mb-3">
            {renderInput()}
        </Form.Group>
    )
}